import type { Language } from '../i18n';
import { formatProjectMoney, formatProjectUsd, usdEstimateNote } from '../lib/project-pricing';

export function ProjectMoney({ amount, language }: { amount: number; language: Language }) {
  return <span className="project-money"><span>{formatProjectMoney(amount, language)}</span>{language === 'en' && <span className="project-money__usd">≈ {formatProjectUsd(amount)}</span>}</span>;
}

export function CurrencyNote({ language }: { language: Language }) {
  return language === 'en' ? <p className="project-currency-note">{usdEstimateNote}</p> : null;
}
